import * as d3 from "d3";
// import * as d3 from "../../libs/d3.min.js";

/**@description 
 * @param {Object} target html-node where to append the svg
 *
 */

function D3Scheduler(target) {

    var self = this;

    // object for event
    /**
     *
     * @param {any} id
     * @param {any} personId
     * @param {any} dateTime
     * @param {any} type
     * @param {any} text
     * @param {number} duration possible values are 1 or 0.5
     */
    self.D3SchedulerEvent = function (id, personId, dateTime, type, text, duration) {
        var self = this;
        self.Id = id;
        self.Type = type;
        self.Text = text;
        self.PersonId = personId;
        self.DateTime = dateTime;
        self.Duration = duration;
    }
    // object for person
    self.D3SchedulerPerson = function (id, name, groupName) {
        var self = this;
        self.Id = id;
        self.Name = name;
        self.GroupName = groupName;
    }

    //
    // public Settings 
    //
    self.Width = 1500;
    self.Height = 800;
    /** Set true to show D3SchedulerEvent.Text */
    self.ShowEventText = false;
    self.ShowPersonGroups = true;
    self.EventShowTextOnMouseOver = false;
    self.EventShowTextOnMouseOverAccessor;
    self.ShowEmptyEventCells = false;
    /** d3 scale for the scheduler/days */
    self.scaleDays;
    self.EventOnClickFn;
    self.Logging = 0;

    var marginleft = 10;
    var margintop = 10;
    var settings = {
        grpHeaderDays: {
            spacer: 0,
            spacerTop: 0,
            height: 30,
            width: function () { return unwrap(settings.grpEvents.width); },
            textMarginLeft: 2,
            y: function () { return unwrap(settings.grpHeaderWeeks.y) + unwrap(settings.grpHeaderWeeks.height) + unwrap(settings.grpHeaderWeeks.spacerTop) + unwrap(settings.grpHeaderDays.spacerTop); },
            x: function () { return unwrap(settings.grpEvents.x); }
        },
        grpHeaderWeeks: {
            spacer: 0,
            spacerTop: 0,
            height: 14,
            width: function () { return (unwrap(settings.grpEvents.width) + unwrap(settings.grpHeaderWeeks.spacer)) * 7 - unwrap(settings.grpHeaderWeeks.spacer); },
            textMarginLeft: 2,
            y: function () { return unwrap(settings.grpHeaderMonths.y) + unwrap(settings.grpHeaderMonths.height) + unwrap(settings.grpHeaderMonths.spacerTop) + unwrap(settings.grpHeaderWeeks.spacerTop); },
            x: function () { return unwrap(settings.grpEvents.x); }
        },
        grpHeaderMonths: {
            spacer: 0,
            spacerTop: 0,
            height: 18,
            textMarginLeft: 2,
            y: function () { return margintop; },
            x: function () { return unwrap(settings.grpEvents.x); },
            width: null
        },
        grpEvents: {
            spacer: 0,
            spacerTop: 0,
            height: 20,
            width: 25,
            y: function () { return unwrap(settings.grpHeaderDays.y) + unwrap(settings.grpHeaderDays.height) + unwrap(settings.grpHeaderDays.spacerTop) + unwrap(settings.grpEvents.spacerTop); },
            x: function () { return unwrap(marginleft) + unwrap(settings.grpPersons.width) }
        },
        grpPersons: {
            grpGruppen: {
                marginTextLeft: 3
            },
            width: 250,
            spacerTop: 0,
            marginTextTop: -6,
            marginTextLeft: 3,
            y: function () { return unwrap(settings.grpEvents.y); }
        },
        scrollBarX: {
            width: 100,
            height: 15,
            y: function () { return self.Height - unwrap(settings.scrollBarX.height); },
            x: function () { return unwrap(settings.grpEvents.x); }
        },
        scrollBarY: {
            width: 15,
            height: 100,
            y: function () { return unwrap(settings.grpEvents.y); },
            x: function () { return self.Width - settings.scrollBarY.width; }
        }
    };

    /** @type {D3SchedulerPerson} */
    self.Persons = [];
    /** @type {D3SchedulerEvent[]} */
    self.Events = [];

    var svg = null;
    var groupHeaderWeeks = null;
    var groupHeaderMonth = null;
    var groupHeaderDay = null;
    var groupPersons = null;
    var groupEvents = null;

    var scrollerX = null;
    var scrollerY = null;
    var scrollerRightBottomCorner = null;

    var scrollerScaleX = d3.scale.linear();
    var scrollerScaleY = d3.scale.linear();

    /**@description gets the person index/row
     * @param {} id Peronsid to find
     * @returns {number} index row; returns -1 if the persont wasnt found
     */
    var getPersonRow : (id: string) => number = function (id) {
        for (var i in self.Persons) {
            if (self.Persons[i].Id === id) {
                return parseInt(i);
            }
        }
        return -1;
    };

    /**@description returns the val as val - unwrap a function (like ko.unwrap())
     * @param {mixed} val if val is an function it will invoked and the return value will be returned else the value self will be returned
     * @returns {mixed} value
     */
    var unwrap = function (val) {
        if (typeof val === "function") {
            return val();
        }
        return val;
    };

    /**@description appends an arrow with an background rect on the given target
     * @param {Object} target d3-selection target
     * @param {Function} scrollFn function to call on scroll event (click event)
     * @param {Function|Number} the Diff-Scroll which is passed as agrument to the scrollFn
     * @returns {Object} d3 selection on created arrow-path
     */
    var getScrollArrow = function (target, scrollFn, scrollDif) {
        target.append("rect")
            .attr("height", 100)
            .attr("width", 100)
            .classed("ScrollbarArrowBackground", true)
            .on("mouseover", function (d, i) { d3.select(this).classed("hover", true); })
            .on("mouseout", function (d, i) { d3.select(this).classed("hover", false); })
            .on("click", function (d, i) { scrollFn(unwrap(scrollDif)); });
        return target.append("path")
            .attr("d", "M25,25L75,50L25,75")
            .classed("ScrollbarArrow", true)
            .style("fill", "none")
            .style("stroke", "black")
            .style("stroke-width", "3px")
            .on("mouseover", function (d, i) {
                d3.select(d3.select(this).node().parentNode).selectAll("rect").classed("hover", true);
            })
            .on("mouseout", function (d, i) {
                d3.select(d3.select(this).node().parentNode).selectAll("rect").classed("hover", false);
            })
            .on("click", function (d, i) { scrollFn(unwrap(scrollDif)); });
    };



    // get scrollbar working!
    /**@description calculate new viewport and sets scrollbars position
     * @param {Number} dragDifference difference from drag start to drag end
     * @param {Object} scroller d3 Selection on Scrollbar (x or y scrollbar)
     * @param {String} scrolltype valid options: "x" or "y"
     * @param {scrollerScale} Scale function (difference for x and y)
     * @param {Number} maxScrollPosition max position for scrollbar position
     */
    var scrollEvent = function (dragDifference, scroller, scrolltype, scrollerScale, maxScrollPosition) {
        var scrollerOrigin = Number(scroller.attr(scrolltype));
        var newScrollerPosition = scrollerOrigin + dragDifference;

        // nicht nach links/rechts/oben/unten raus scrollen lassen
        if (newScrollerPosition < d3.min(scrollerScale.domain())) {
            newScrollerPosition = d3.min(scrollerScale.domain());
        } else if (newScrollerPosition > d3.max(scrollerScale.domain())) {
            newScrollerPosition = d3.max(scrollerScale.domain());
        }

        var scrollToPos = scrollerScale(newScrollerPosition);
        // wenn nicht gescrollt werden muss muss nicht gescrollt werden! 
        if (dragDifference > 0 && scrollToPos < 0) {
            return;
        }

        if (scrolltype === "x") {
            scrollTo(scrollToPos * (-1), null);
        } else if (scrolltype === "y") {
            scrollTo(null, scrollToPos * (-1));
        }
        scroller.attr(scrolltype, newScrollerPosition);
    };
    var scrollEventX = function (dx) {
        scrollEvent(dx, scrollerX, "x", scrollerScaleX, (self.Width - unwrap(settings.scrollBarX.width) - unwrap(settings.scrollBarY.width) * 2));
    };
    var scrollEventY = function (dy) {
        scrollEvent(dy, scrollerY, "y", scrollerScaleY, (self.Height - unwrap(settings.scrollBarY.height) - unwrap(settings.scrollBarX.height) * 2));
    };

    /**
     *
     */
    var drawHeaderWeeks = function () {
        var spacer = unwrap(settings.grpHeaderWeeks.spacer);
        var spacerTextBorderLeft = unwrap(settings.grpHeaderWeeks.textMarginLeft);
        var w = unwrap(settings.grpHeaderWeeks.width);
        var h = unwrap(settings.grpHeaderWeeks.height);

        var startdate = d3.time.monday.floor(self.scaleDays.domain()[0]);
        var enddate = d3.time.day.offset(self.scaleDays.domain()[1],1);

        var selection;

        selection = groupHeaderWeeks.selectAll("rect")
            .data(d3.time.monday.range(startdate, enddate));
        selection.enter()
            .append("rect")
            .attr("height", h);
        selection
            .attr("x", function (d, i) {
                if (self.scaleDays(d) < 0)
                    return 0;
                return self.scaleDays(d);
            })
            .attr("width", function (d) {
                if (self.scaleDays(d) < 0) {
                    return w + self.scaleDays(d);
                }
                if ((self.scaleDays(d) + w) > (d3.max(self.scaleDays.range()) + unwrap(settings.grpEvents.width))) {
                    return (d3.max(self.scaleDays.range()) + unwrap(settings.grpEvents.width) - (self.scaleDays(d)));
                }
                return w;
            });
        selection.exit().remove();

        selection = groupHeaderWeeks.selectAll("text")
            .data(d3.time.monday.range(startdate, enddate));
        selection.enter()
            .append("text")
            .attr("y", h - 2)
            .style("text-anchor", "middle");
        selection
            .attr("x", function (d, i) {
                if (self.scaleDays(d) < 0) {
                    return (self.scaleDays(d) + w) / 2;
                }
                if ((self.scaleDays(d) + w) > (d3.max(self.scaleDays.range()) + unwrap(settings.grpEvents.width))) {
                    return self.scaleDays(d) + (d3.max(self.scaleDays.range()) + unwrap(settings.grpEvents.width) - (self.scaleDays(d))) / 2;
                }
                return self.scaleDays(d) + w / 2;
            })
            .text(function (d, i) {
                var widthRect = w;
                if (self.scaleDays(d) < 0) {
                    widthRect =  w + self.scaleDays(d);
                }
                if ((self.scaleDays(d) + w) > (d3.max(self.scaleDays.range()) + unwrap(settings.grpEvents.width))) {
                    widthRect = (d3.max(self.scaleDays.range()) + unwrap(settings.grpEvents.width) - (self.scaleDays(d)));
                }
                // check if there is enought space for the wording
                if (widthRect > 30)
                    return "KW " + d3.time.format("%W")(d);
                return "";
            });
        selection.exit().remove();
    };

    /**
     *
     */
    var drawHeaderMonth = function () {
        var spacer = unwrap(settings.grpHeaderMonths.spacer);
        var spacerTextBorderLeft = unwrap(settings.grpHeaderMonths.textMarginLeft);
        var w = unwrap(settings.grpHeaderMonths.width);
        var h = unwrap(settings.grpHeaderMonths.height);


        var startdate = d3.time.month.floor(self.scaleDays.domain()[0]);
        var enddate = self.scaleDays.domain()[1];

        var selection;

        selection = groupHeaderMonth.selectAll("rect")
            .data(d3.time.month.range(startdate, enddate));
        selection.enter()
            .append("rect")
            .attr("height", h);
        selection
            .attr("x", function (d, i) {
                if (self.scaleDays(d) < 0)
                    return 0;
                return self.scaleDays(d);
            })
            .attr("width", function (d, i) {
                return d3.time.days(d, d3.time.month.offset(d, 1)).length * (unwrap(settings.grpEvents.width) + unwrap(settings.grpEvents.spacer)) - unwrap(settings.grpHeaderMonths.spacer);
            });
        selection.exit().remove();

        selection = groupHeaderMonth.selectAll("text")
            .data(d3.time.month.range(startdate, enddate));
        selection.enter()
            .append("text")
            .attr("y", h - 4)
            .style("text-anchor", "middle");
        selection
            .attr("x", function (d, i) {
                if (self.scaleDays(d) < 0)
                    return (self.scaleDays(d) + (d3.time.days(d, d3.time.month.offset(d, 1)).length * (unwrap(settings.grpEvents.width) + unwrap(settings.grpEvents.spacer)) - unwrap(settings.grpHeaderMonths.spacer))) / 2;
                return self.scaleDays(d) + (d3.time.days(d, d3.time.month.offset(d, 1)).length * (unwrap(settings.grpEvents.width) + unwrap(settings.grpEvents.spacer)) - unwrap(settings.grpHeaderMonths.spacer)) / 2;
            })
            .text(function (d, i) {
                // check if there is enought space for the wording
                if (d3.time.days(d, d3.time.month.offset(d, 1)).length * (unwrap(settings.grpEvents.width) + unwrap(settings.grpEvents.spacer)) - unwrap(settings.grpHeaderMonths.spacer) > 35)
                    return d3.time.format("%B")(d);
                return "";
            });
        selection.exit().remove();
    };

    var drawHeaderDays = function () {
        var spacer = unwrap(settings.grpHeaderDays.spacer);
        var spacerTextBorderLeft = unwrap(settings.grpHeaderDays.textMarginLeft);
        var w = unwrap(settings.grpHeaderDays.width);
        var h = unwrap(settings.grpHeaderDays.height);


        var startdate = self.scaleDays.domain()[0];
        var enddate = d3.time.day.offset(self.scaleDays.domain()[1], 1);

        var selection;

        selection = groupHeaderDay.selectAll("rect")
            .data(d3.time.day.range(startdate, enddate));
        selection.enter()
            .append("rect")
            .attr("height", h)
            .attr("width", w);
        selection
            .attr("x", function (d, i) {
                log(d);
                return self.scaleDays(d);
            })
            .classed("HeaderWeekend", function (d) {
                return (d3.time.format("%w")(d) === "0" || d3.time.format("%w")(d) === "6");
            });
        selection.exit().remove();

        selection = groupHeaderDay.selectAll("text.weekdayname")
            .data(d3.time.day.range(startdate, enddate));
        selection.enter()
            .append("text")
            .attr("class", "weekdayname")
            .attr("y", h - 2 - 15)
            .style("text-anchor", "middle");
        selection
            .attr("x", function (d, i) {
                return self.scaleDays(d) + w / 2;
            })
            .text(function (d, i) {
                return d3.time.format("%d")(d);
            });
        selection.exit().remove();
        selection = groupHeaderDay.selectAll("text.day")
            .data(d3.time.day.range(startdate, enddate));
        selection.enter()
            .append("text")
            .attr("class", "day")
            .attr("y", h + 15 - 18)
            .style("text-anchor", "middle");
        selection
            .attr("x", function (d, i) {
                return self.scaleDays(d) + w / 2;
            })
            .text(function (d, i) {
                return d3.time.format("%a")(d);
            });
        selection.exit().remove();
    };

    /**@description prints head for persons: is static so only call on init
     * 
     */
    var drawHeaderPersons = function () {
        var grpHeaderPersons = svg.append("g")
            .classed("headerPersons", true)
            .attr("transform", "translate(" + marginleft + "," + margintop + ")");

        var personWidth = unwrap(settings.grpPersons.width) - unwrap(settings.grpEvents.spacerTop);
        var personX = 0;
        if (self.ShowPersonGroups === true) {
            // group
            grpHeaderPersons.append("rect")
                .attr("width", unwrap(settings.grpPersons.width) / 5 * 2 - unwrap(settings.grpEvents.spacerTop))
                .attr("height", unwrap(settings.grpPersons.y) - margintop - unwrap(settings.grpEvents.spacerTop) * 2);
            grpHeaderPersons.append("text")
                .attr("x", (unwrap(settings.grpPersons.width) / 5 * 2 - unwrap(settings.grpEvents.spacerTop)) / 2)
                .attr("y", (unwrap(settings.grpPersons.y) - margintop - unwrap(settings.grpEvents.spacerTop) * 2) / 2 + 3)
                .style("text-anchor", "middle")
                .text("Bereich");
            // adjust person width
            personWidth = unwrap(settings.grpPersons.width) / 5 * 3 - unwrap(settings.grpEvents.spacerTop);
            personX = unwrap(settings.grpPersons.width) / 5 * 2 - unwrap(settings.grpEvents.spacerTop) + unwrap(settings.grpEvents.spacer);
        }

        // person
        grpHeaderPersons.append("rect")
            .attr("x", personX)
            .attr("width", personWidth)
            .attr("height", unwrap(settings.grpPersons.y) - margintop - unwrap(settings.grpEvents.spacerTop) * 2);
        grpHeaderPersons.append("text")
            .attr("x", personX + personWidth / 2)
            .attr("y", (unwrap(settings.grpPersons.y) - margintop - unwrap(settings.grpEvents.spacerTop) * 2) / 2 + 3)
            .style("text-anchor", "middle")
            .text("Name");

    };

    /**
     *
     */
    var drawPersons = function () {

        var selection;

        var personX = marginleft;
        var personWidth = unwrap(settings.grpPersons.width) - unwrap(settings.grpEvents.spacerTop);
        if (self.ShowPersonGroups === true) {

            var nestedGroups = d3.nest()
                .key(function (d: any) { return d.GroupName; })
                .key(function (d: any) { return d.Id; })
                .entries(self.Persons);

            var currentGroupPosition = 0;

            selection = groupPersons.selectAll("rect.PersonGroups")
                .data(nestedGroups);
            selection.enter()
                .append("rect")
                .attr("class", "PersonGroups")
                .attr("x", marginleft)
                .attr("width", unwrap(settings.grpPersons.width) / 5 * 2 - unwrap(settings.grpEvents.spacerTop));
            selection
                .attr("y", function (d) {
                    var tmp = (unwrap(settings.grpEvents.height) + unwrap(settings.grpEvents.spacer)) * currentGroupPosition + unwrap(settings.grpPersons.y);
                    currentGroupPosition += d.values.length;
                    return tmp;
                })
                .attr("height", function (d) { return d.values.length * (unwrap(settings.grpEvents.height) + unwrap(settings.grpEvents.spacer)) - unwrap(settings.grpEvents.spacer) });
            selection.exit().remove();
            currentGroupPosition = 0;
            selection = groupPersons.selectAll("text.PersonGroups")
                .data(nestedGroups);
            selection.enter()
                .append("text")
                .attr("class", "PersonGroups")
                .attr("x", marginleft + unwrap(settings.grpPersons.grpGruppen.marginTextLeft));
            selection
                .attr("y", function (d) {
                    // calc default y
                    var tmp = (unwrap(settings.grpEvents.height) + unwrap(settings.grpEvents.spacer)) * currentGroupPosition + unwrap(settings.grpPersons.y);
                    currentGroupPosition += d.values.length;
                    // y + text position
                    return tmp + (d.values.length * (unwrap(settings.grpEvents.height) + unwrap(settings.grpEvents.spacer)) - unwrap(settings.grpEvents.spacer)) / 2 + 6;
                })
                .text(function (d) { return "" + d.key; });
            selection.exit().remove();

            // adjust person values:
            personX = marginleft + (unwrap(settings.grpPersons.width) / 5 * 2);
            personWidth = unwrap(settings.grpPersons.width) / 5 * 3 - unwrap(settings.grpEvents.spacerTop);
        }


        selection = groupPersons.selectAll("rect.Persons")
            .data(self.Persons);
        selection.enter()
            .append("rect")
            .attr("class", "Persons")
            .attr("x", personX)
            .attr("height", unwrap(settings.grpEvents.height))
            .attr("width", personWidth);
        selection
            .attr("y", function (d, i) {
                return (i + 0) * (unwrap(settings.grpEvents.height) + unwrap(settings.grpEvents.spacer))
                    + unwrap(settings.grpPersons.y);
            });
        selection.exit().remove();
        selection = groupPersons.selectAll("text.Persons")
            .data(self.Persons);
        selection.enter()
            .append("text")
            .attr("class", "Persons")
            .attr("class", "personNames")
            .attr("x", personX + unwrap(settings.grpPersons.marginTextLeft));
        selection
            .attr("y", function (d, i) {
                return (i + 1) * (unwrap(settings.grpEvents.height) + unwrap(settings.grpEvents.spacer))
                    + unwrap(settings.grpPersons.y) + unwrap(settings.grpPersons.marginTextTop);
            })
            .text(function (d, i) { return d.Name ? d.Name : "Default Name " + (i + 1); });
        selection.exit().remove();

    };
    
    var MouseOverShowToolTip = function (d, accessor) {

        if (accessor(d) === "") {
            return;
        }

        svg.selectAll("g.ToolTip").remove();
        var grp = svg.append("svg:g")
            .classed("ToolTip", true)
            .on("mouseout", function (d) {
                //d3.select(this).selectAll("rect").style("fill", "red");
                d3.select(this).transition().delay(350).remove();
            })
            .on("mouseover", function () { d3.select(this).transition(); });

        svg.selectAll("g.ToolTip").transition().delay(1500).remove();

        var box = grp.append("svg:rect")
            .attr("x", (<any>d3.event).offsetX)
            .attr("y", (<any>d3.event).offsetY);

        var textext = accessor(d);
        var text = grp.append("svg:text")
            .attr("x", (<any>d3.event).offsetX + 2)
            .attr("y", (<any>d3.event).offsetY + 14)
            .text(textext);
    };
    var defaultEventOnClickFn = function (d) {
        var box = svg.append("svg:rect")
            .attr("width", 200)
            .attr("height", 100)
            .attr("x", (<any>d3.event).offsetX)
            .attr("y", (<any>d3.event).offsetY)
            .style("fill", "white")
            .style("stroke", "black");
        var text = svg.append("svg:text")
            .attr("x", (<any>d3.event).offsetX + 2)
            .attr("y", (<any>d3.event).offsetY + 14)
            .text("Id: " + d.Id + " \n" + d3.time.format("%x")(d.DateTime));
        box.transition().delay(1500).remove();
        text.transition().delay(1500).remove();
        //log("a", d.Id, d3.event);
    };

    /**@description draws the event-section
     * @param {type} [cstmEvents] optional custom event-data
     */
    var drawEvents = function (cstmEvents?) {
        var selection;
        var w = unwrap(settings.grpEvents.width);
        var h = unwrap(settings.grpEvents.height);
        var spacer = unwrap(settings.grpEvents.spacer);
        var spacerHeight = unwrap(settings.grpEvents.spacer);

        var events;
        if(typeof cstmEvents === "undefined"){
            // only get events which are in the given domain
            events = getFilteredEvents();
        } else {
            events = cstmEvents;
        }

        var onclickFn = defaultEventOnClickFn;
        if (typeof self.EventOnClickFn === "function") {
            onclickFn = self.EventOnClickFn;
        }

        selection = groupEvents.selectAll("rect")
            .data(events.filter(function (val) {
                // take only events with duration is default or 1 day
                return (typeof val.Duration === "undefined" || val.Duration !== 0.5)
            }))
        selection.enter()
            .append("rect")
            .attr("class", "schedulerEvent")
            .attr("height", h)
            .attr("width", w)
            .on("click", onclickFn);
        selection
            .attr("x", function (d, i) {
                log("event", d.DateTime);
                return self.scaleDays(d.DateTime);
            })
            .attr("y", function (d, i) { return getPersonRow(d.PersonId) * (h + spacerHeight); })
            .attr("class", function (d) {
                return d.Type;
            });
        if (self.EventShowTextOnMouseOver === true) {
            selection.on("mouseover", function (d) {
                MouseOverShowToolTip(d, self.EventShowTextOnMouseOverAccessor);
            });
        }
        selection.exit().remove();

        // half days:
        selection = groupEvents.selectAll("polygon")
            .data(events.filter(function (val) {
                // take only events with duration is default or 1 day
                return (typeof val.Duration !== "undefined" && val.Duration === 0.5)
            }))
        selection.enter()
            .append("polygon")
            .attr("class", "schedulerEvent")
            .on("click", onclickFn)
            .attr("stroke", "black")
            .attr("stroke-width", "1px")
            .attr("fill","lime");
        selection
            .attr("points", function (d) {
                return "" + self.scaleDays(d.DateTime) + "," + (getPersonRow(d.PersonId) * (h + spacerHeight) + h) + " "
                    + self.scaleDays(d.DateTime) + "," + (getPersonRow(d.PersonId) * (h + spacerHeight)) + " "
                    + (self.scaleDays(d.DateTime) + w) + "," + (getPersonRow(d.PersonId) * (h + spacerHeight));
            })
            .attr("class", function (d) {
                return d.Type;
            });
        if (self.EventShowTextOnMouseOver === true) {
            selection.on("mouseover", function (d) {
                MouseOverShowToolTip(d, self.EventShowTextOnMouseOverAccessor);
            });
        }
        selection.exit().remove();

        if (self.ShowEventText) {
            selection = groupEvents.selectAll("text")
                .data(events);
            selection.enter()
                .append("text")
                .style("text-anchor", "middle")
                .on("click", onclickFn)
                .attr("class", "schedulerEventText");
            selection
                .attr("x", function (d, i) {
                    return self.scaleDays(d.DateTime) + w / 2;
                })
                .attr("y", function (d, i) { return <number>getPersonRow(d.PersonId) * (h + spacerHeight) + h / 10 * 7; })
                .attr("class", function (d) {
                    return d.Type;
                })
                .text(function (d) { return d.Text; });
            selection.exit().remove();
        }

    };

    var getFilteredEvents = function(){
        return self.Events.filter(function (val) { return (val.DateTime >= self.scaleDays.domain()[0] && val.DateTime <= self.scaleDays.domain()[1]) });
    };

    /**@description generate events for every Person in everyDay and calls drawEvent with this extended data
     * 
     */
    var drawEventsWithEmptyCells = function(){
        
        var stdEvents = getFilteredEvents()
        var emptyEvents = [];

        var startdate = self.scaleDays.domain()[0];
        var enddate = d3.time.day.offset(self.scaleDays.domain()[1], 1);

        var daysRange = d3.time.day.range(startdate, enddate);

        for (var zP in self.Persons) {
            var person = self.Persons[zP];
            for (var zD in daysRange) {
                var day = daysRange[zD];
                emptyEvents.push({
                    Id: "EmptyEvent"+zP+"."+zD,
                    Type: "EmptyEvent",
                    Text: "",
                    PersonId: person.Id,
                    DateTime: day});
            }
        }

        var events = emptyEvents.concat(stdEvents);
        drawEvents(events);

    };

    var getEventsWidth = function () {
        var start = self.scaleDays.domain()[0];
        var end = self.scaleDays.domain()[1];
        var cntDays = d3.time.days(start, end).length + 1;
        var widthPerDay = unwrap(settings.grpEvents.width) + unwrap(unwrap(settings.grpEvents.spacer));
        return cntDays * widthPerDay;
    };
    var getEventsHeight = function () {
        var cntPersons = self.Persons.length;
        var heightPerPerson = unwrap(settings.grpEvents.height) + unwrap(unwrap(settings.grpEvents.spacer));
        return cntPersons * heightPerPerson;
    };
    var initScroll = function () {
        // x
        scrollerScaleX
            // x-scrollbar-position-start -  x-scrollbar-position-max
            .domain([
                // x-position + arrow-btn
                unwrap(settings.scrollBarX.x) + unwrap(settings.scrollBarX.height),
                self.Width - unwrap(settings.scrollBarX.width) - unwrap(settings.scrollBarY.width) * 2
            ])
            .range([
                0,
                getEventsWidth() - self.Width + marginleft + unwrap(settings.grpPersons.width) + unwrap(settings.scrollBarY.width)
            ]);

        // y
        scrollerScaleY
            // y-scrollbar-position-start -  x-scrollbar-position-max
            .domain([
                unwrap(settings.scrollBarY.y) + unwrap(settings.scrollBarY.width),
                self.Height - unwrap(settings.scrollBarY.height) - unwrap(settings.scrollBarX.height) * 2
            ])
            .range([
                    0,
                    getEventsHeight() - self.Height + unwrap(settings.grpEvents.y) + unwrap(settings.scrollBarX.height)
            ]);
        // hide scrollbars if they are not necessary
        if (getEventsWidth() <= self.Width - unwrap(settings.scrollBarY.width) - unwrap(settings.grpEvents.x)) {
            scrollbarGroupX.attr("visibility", "hidden");
        } else {
            scrollbarGroupX.attr("visibility", null);
        }
        if (getEventsHeight() <= self.Height - unwrap(settings.scrollBarX.height) - unwrap(settings.grpEvents.y)) {
            scrollbarGroupY.attr("visibility", "hidden");
        } else {
            scrollbarGroupY.attr("visibility", null);
        }
    };

    /** @description draws or redraws the scheduler
     *
     */
    self.draw = function () {
        if (initialized !== true) {
            init();
            // is static must be only called at init
            drawHeaderPersons();
            initialized = true;
        }
        drawHeaderWeeks();
        drawHeaderMonth();
        drawHeaderDays();
        drawPersons();
        if (self.ShowEmptyEventCells === true) {
            drawEventsWithEmptyCells();
        } else {
            drawEvents();
        }
        initScroll();
        // init scrolling position. scroll to 0,0
        scrollTo(0, 0);
        // set scrollbars back to their start position
        scrollerX.attr("x", unwrap(settings.scrollBarX.x) + unwrap(settings.scrollBarX.height));
        scrollerY.attr("y", unwrap(settings.scrollBarY.y) + unwrap(settings.scrollBarY.width));
    };

    //
    // init
    //
    var initialized = false;
    var whiteBorderEventsTop, whiteBorderEventsLeft, whiteBorderPersonsTop, scrollerXWhiteBorder, scrollerXBackground, scrollerYWhiteBorder,
        scrollerYBackground, scrollerRightBottomCornervar, scrollerHW, scrollDiff, transformScale, scrollerXLeftArrowG, scrollerXLeftArrowPath,
        scrollerXRightArrowG, scrollerXRightArrowPath, scrollerYTopArrowG, scrollerYTopArrowPath, scrollerYBotArrowG, scrollerYBotArrowPath,
        oldScrollToValues, drag, dragY, zoom, scrollbarGroupX, scrollbarGroupY;
    /**@description draws initial elements which are needs only once and registers scroll events
     * 
     */
    var init = function () {

        // create svg elements. Reihenfolge ist wichtig, da sich die Element entsprechend überlappen beim scrollen
        svg = d3.select(target).append("svg")
            .attr("width", self.Width)
            .attr("height", self.Height);

        groupEvents = svg.append("g")
            .attr("class", "events");
        //.attr("transform", "translate(" + (marginleft + unwrap(settings.grpPersons.width)) + ", " + unwrap(settings.grpEvents.y) + ")");
        whiteBorderEventsTop = svg.append("svg:rect")
            .attr("height", unwrap(settings.grpEvents.y) - 1)
            .attr("width", self.Width)
            .classed("EventGroupScrollBorder", true);
        groupHeaderWeeks = svg.append("g")
            .attr("class", "header")
            .attr("transform", "translate(" + unwrap(settings.grpPersons.width) + "," + unwrap(settings.grpHeaderWeeks.y) + ")");
        groupHeaderMonth = svg.append("g")
            .attr("class", "headerMonth")
            .attr("transform", "translate(" + (marginleft + unwrap(settings.grpPersons.width)) + "," + unwrap(settings.grpHeaderMonths.y) + ")");
        groupHeaderDay = svg.append("g")
            .attr("class", "headerDay")
            .attr("transform", "translate(" + (marginleft + unwrap(settings.grpPersons.width)) + "," + unwrap(settings.grpHeaderDays.y) + ")");
        whiteBorderEventsLeft = svg.append("svg:rect")
            .attr("height", self.Height)
            .attr("width", unwrap(settings.grpPersons.width) + marginleft)
            .classed("EventGroupScrollBorder", true);
        groupPersons = svg.append("g").attr("class", "persons");
        whiteBorderPersonsTop = svg.append("svg:rect")
            .attr("height", unwrap(settings.grpEvents.y) - 1)
            .attr("width", unwrap(settings.grpPersons.width) + marginleft)
            .classed("EventGroupScrollBorder", true);
        scrollbarGroupX = svg.append("g").classed("scrollbarGroupX",true);
        scrollbarGroupY = svg.append("g").classed("scrollbarGroupY", true);
        // white border on the left bottom corner (persons)...
        scrollerXWhiteBorder = scrollbarGroupX.append("rect")
            .attr("class", "scrollerMarginBorder ScrollbarX")
            .attr("height", unwrap(settings.scrollBarX.height))
            .attr("width", unwrap(settings.grpPersons.width) + marginleft)
            .attr("x", unwrap(settings.grpEvents.x))
            .attr("y", unwrap(settings.scrollBarX.y));
        scrollerXBackground = scrollbarGroupX.append("rect")
            .attr("class", "scrollerBackground ScrollbarX")
            .attr("height", unwrap(settings.scrollBarX.height))
            .attr("width", self.Width - unwrap(settings.grpPersons.width))
            .attr("x", unwrap(settings.scrollBarX.x))
            .attr("y", unwrap(settings.scrollBarX.y));

        // white border on the right top corner (Month+Week Header)...
        scrollerYWhiteBorder = scrollbarGroupY.append("rect")
            .attr("class", "scrollerMarginBorder ScrollbarY")
            .attr("height", unwrap(settings.scrollBarY.height))
            .attr("width", unwrap(settings.scrollBarY.width))
            .attr("x", unwrap(settings.scrollBarY.x))
            .attr("y", 0);
        scrollerYBackground = scrollbarGroupY.append("rect")
            .attr("class", "scrollerBackground ScrollbarY")
            .attr("height", self.Height)
            .attr("width", unwrap(settings.scrollBarY.width))
            .attr("x", unwrap(settings.scrollBarY.x))
            .attr("y", unwrap(settings.scrollBarY.y));
        scrollerX = scrollbarGroupX.append("rect")
            .attr("class", "Scroller ScrollbarX")
            .attr("height", unwrap(settings.scrollBarX.height))
            .attr("width", unwrap(settings.scrollBarX.width))
            .attr("x", unwrap(settings.scrollBarX.x) + unwrap(settings.scrollBarX.height))
            .attr("y", unwrap(settings.scrollBarX.y))
            .on("mouseover", function (d, i) { d3.select(this).classed("hover", true); })
            .on("mouseout", function (d, i) { d3.select(this).classed("hover", false); });
        scrollerY = scrollbarGroupY.append("rect")
            .attr("class", "Scroller ScrollbarY")
            .attr("height", unwrap(settings.scrollBarY.height))
            .attr("width", unwrap(settings.scrollBarY.width))
            .attr("x", unwrap(settings.scrollBarY.x))
            .attr("y", unwrap(settings.grpEvents.y) + unwrap(settings.scrollBarY.width))
            .on("mouseover", function (d, i) { d3.select(this).classed("hover", true); })
            .on("mouseout", function (d, i) { d3.select(this).classed("hover", false); });
        scrollerRightBottomCorner = scrollbarGroupX.append("rect")
            .attr("class", "ScrollerRightBottomCorner")
            .attr("height", unwrap(settings.scrollBarX.height))
            .attr("width", unwrap(settings.scrollBarY.height))
            .attr("x", unwrap(settings.scrollBarY.x))
            .attr("y", unwrap(settings.scrollBarX.y));

        scrollerHW = unwrap(settings.scrollBarX.height);
        scrollDiff = unwrap(settings.grpEvents.height);
        transformScale = "scale(" + (0.01 * scrollerHW) + ", " + (0.01 * scrollerHW) + ")";
        scrollerXLeftArrowG = scrollbarGroupX.append("g")
            .attr("transform", "translate(" + (unwrap(settings.scrollBarX.x)) + "," + (unwrap(settings.scrollBarX.y)) + ") " + transformScale + " rotate(180, 50, 50) ");
        scrollerXLeftArrowPath = getScrollArrow(scrollerXLeftArrowG, scrollEventX, scrollDiff * -1);
        scrollerXRightArrowG = scrollbarGroupX.append("g")
            .attr("transform", "translate(" + (self.Width - scrollerHW * 2) + "," + (unwrap(settings.scrollBarX.y)) + ") " + transformScale + "");
        scrollerXRightArrowPath = getScrollArrow(scrollerXRightArrowG, scrollEventX, scrollDiff);

        scrollerYTopArrowG = scrollbarGroupY.append("g")
            .attr("transform", "translate(" + unwrap(settings.scrollBarY.x) + "," + (unwrap(settings.scrollBarY.y)) + ") " + transformScale + " rotate(270, 50, 50)");
        scrollerYTopArrowPath = getScrollArrow(scrollerYTopArrowG, scrollEventY, scrollDiff * -1);
        scrollerYBotArrowG = scrollbarGroupY.append("g")
            .attr("transform", "translate(" + unwrap(settings.scrollBarY.x) + "," + (self.Height - unwrap(settings.scrollBarX.height) * 2) + ") " + transformScale + " rotate(90, 50, 50)");
        scrollerYBotArrowPath = getScrollArrow(scrollerYBotArrowG, scrollEventY, scrollDiff);

        oldScrollToValues = { x: 0, y: 0 };

        // drag/scroll behavior for x-axis
        drag = d3.behavior.drag();
        scrollerX.call(drag);
        drag.on("drag", function () { scrollEventX((<any>d3.event).dx); });
        // drag/scroll behavior for y-axis
        dragY = d3.behavior.drag();
        scrollerY.call(dragY);
        dragY.on("drag", function () { scrollEventY((<any>d3.event).dy); });

        zoom = d3.behavior.zoom();
        svg.call(zoom);
        zoom.on("zoom", function () {
            if ((<any>d3.event).sourceEvent !== null && (<any>d3.event).sourceEvent.type === "wheel") {
                scrollEventY(Number((<any>d3.event).sourceEvent.deltaY));
            }
        });

    };

    /**@description set the scale domain
     * @param {mixed} start 
     * @param {mixed} end
     */
    self.SetDomain = function (start, end) {
        start = d3.time.day.round(start);
        end = d3.time.day.round(end);
        var daysOfMonth = d3.time.days(start, end).length;
        var rangemax = daysOfMonth * (unwrap(settings.grpEvents.width) + unwrap(settings.grpEvents.spacer));
        self.scaleDays = d3.time.scale().domain([start, end]).range([0, rangemax]);
    };

    // calculate Scale on time - default this month 
    self.SetDomain(d3.time.month.floor(new Date()), d3.time.month.ceil(new Date()));

    /**@description sets the "viewport" (=several g-nodes) relative to the scroll-position
     * @param {Number} [x] default is last value 
     * @param {Number} [y] default is last value
     */
    var scrollTo = function (x, y?) {
        if (typeof x === "undefined" || x === null) {
            x = oldScrollToValues.x;
        } else {
            oldScrollToValues.x = x;
        }
        if (typeof y === "undefined" || y === null) {
            y = oldScrollToValues.y;
        } else {
            oldScrollToValues.y = y;
        }
        var duration = 50;
        groupEvents.transition().duration(duration).attr("transform", "translate(" + (x + marginleft + unwrap(settings.grpPersons.width)) + ", " + (unwrap(settings.grpEvents.y) + y) + ")" /* scale=zoom: + " scale(" + d3.event.scale + ")"*/)
        groupHeaderWeeks.transition().duration(duration).attr("transform", "translate(" + (x + marginleft + unwrap(settings.grpPersons.width)) + "," + unwrap(settings.grpHeaderWeeks.y) + ")" /* scale=zoom: + " scale(" + d3.event.scale + ")"*/)
        groupHeaderMonth.transition().duration(duration).attr("transform", "translate(" + (x + marginleft + unwrap(settings.grpPersons.width)) + "," + unwrap(settings.grpHeaderMonths.y) + ")" /* scale=zoom: + " scale(" + d3.event.scale + ")"*/)
        groupHeaderDay.transition().duration(duration).attr("transform", "translate(" + (x + marginleft + unwrap(settings.grpPersons.width)) + "," + unwrap(settings.grpHeaderDays.y) + ")" /* scale=zoom: + " scale(" + d3.event.scale + ")"*/)
        groupPersons.transition().duration(duration).attr("transform", "translate(" + 0 + "," + y + ")" /* scale=zoom: + " scale(" + d3.event.scale + ")"*/)
    };


    var log = function (a?, b?) {
        if (self.Logging !== 0) {
            console.log.apply(self, arguments);
        }
    };

    self.dispose = function () {
        // everything is mapped with the dom. even d3 created events. if the dom-node is removed, no other action is needed
    };

}

export default D3Scheduler;